import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { locales, isRTL, supportedLanguages, type SupportedLanguage } from '../locales';

// Convert locale objects to i18next resource format
const resources = Object.fromEntries(
  Object.entries(locales).map(([lang, translations]) => [lang, { translation: translations }])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Handle RTL direction changes
i18n.on('languageChanged', (lng) => {
  const dir = isRTL(lng) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
});

// Set initial direction
const initialLang = i18n.language || 'en';
document.documentElement.dir = isRTL(initialLang) ? 'rtl' : 'ltr';
document.documentElement.lang = initialLang;

export { isRTL, supportedLanguages, type SupportedLanguage };
export default i18n;
